/**
 * Send a new job order log to the AWS Lambda endpoint.
 *
 * @param {string} jobOrderId      - The ID of the job order.
 * @param {string} userUpdate    - The username or identifier of who is updating.
 * @param {object} updatedFields  - The payload saved in the logs.
 * @returns {Promise<Object>}     - The JSON response from the API.
 * @throws {Error}               - If the network request fails or returns non-2xx.
 */

export async function postJobOrderLogs(jobOrderId, userUpdate, updatedFields = {}) {
  const apiUrl = 'https://n3dudz0nsl.execute-api.ap-southeast-1.amazonaws.com/prod/postJobOrderLogs';

  // Build the payload for the API
  const payload = {
    job_order_id: jobOrderId,
    user_update: userUpdate,
    updated_fields: updatedFields
  };

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to save log');
    }

    return data; // Contains { message: 'Log saved', id: 'XXXXXX' }

  } catch (error) {
    console.error('Error posting job order log:', error);
    throw error; // Re-throw the error to handle it in your component
  }
}


/**
 * Fetch logs for a given job order ID.
 *
 * @param {string} jobOrderId      - The ID of the job order.
 * @returns {Promise<Array>}     - An array of log objects.
 * @throws {Error}               - If the network request fails or returns non-2xx.
 */

// New function: Get job order logs by ID
export async function getJobOrderLogsById(jobOrderId) {
  const apiUrl = `https://l88r8c7cx3.execute-api.ap-southeast-1.amazonaws.com/prod/getJobOrderLogsById/${jobOrderId}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch job order logs');
    }

    return data.data; // Returns the array inside 'data' key

  } catch (error) {
    console.error('Error fetching job order logs:', error);
    throw error;
  }
}
